import React from 'react'
import * as ReactDOMServer from 'react-dom/server'

const decodeEntity = inputStr => {
  const textarea = document.createElement('textarea')
  textarea.innerHTML = inputStr
  return textarea.value
}

const mapChild = (child, i, depth) => {
  if (child.tagName) {
    const className =
      child.properties && Array.isArray(child.properties.className)
        ? child.properties.className.join(' ')
        : child.properties.className

    return decodeEntity(
      ReactDOMServer.renderToString(
        React.createElement(
          child.tagName,
          { ...child.properties, className },
          child.children && child.children.map(mapWithDepth(depth + 1))
        )
      )
    )
  }

  return child.value
}

export const mapWithDepth = depth => (child, i) => mapChild(child, i, depth)
